import { environment } from "../commons/enviroment";

export const TenantService = {
    canActivateFaq: (tenantName) => {
        const tenant = environment.tenants.find(tenant => tenant.tenant === tenantName);
        return tenant && tenant.canActivateRoute && tenant.canActivateRoute.preguntasFrecuentes;
    },
};
